import React, { Component } from 'react';
import '../css/ticketRef.css'
import $ from 'jquery';

function BarCode({ folioBarcode }) {
    return <img alt="" />;
}


class RefSaleModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { CloseBillModal } = this.props;
        $('#refSaleModal').on('hidden.bs.modal', function () {
            CloseBillModal(true);
        });
    };


    render() {
        const { Folio, PrintRefSale, _user } = this.props;
        return (
            <div className="modal fade" id="refSaleModal" role="dialog" tabIndex="-1" aria-labelledby="refSaleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ backgroundColor: "#fff0", border: "none" }}>
                        <div className="modal-body">
                            <div className="ticketRef" style={{ fontSize: 12 }}>
                                <div className="m-3">
                                    <div className="" >
                                        <div className="text-center" >
                                            <img className="img-fluid d-block mx-auto" src={require('../images/logoTicket.png')} style={{ maxWidth: "200px" }} alt="COUNTER ONE"></img>
                                            <p>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</p>
                                            <p>{_user?.Branch.Address.toUpperCase()}</p>
                                            <p>N° </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="text-center ">
                                        <div className="pr-2 pl-2">
                                            <BarCode folioBarcode={Folio} />
                                            <h3><strong>{Folio}</strong></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right" style={{ marginTop: "60px" }}>
                                    <button className="btn" onClick={() => PrintRefSale("RefSale", "80", Folio)}><i className="fa fa-print" aria-hidden="true" style={{ fontSize: "25px", color: "#80808073" }}></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RefSaleModal;